import axiosInstance from "./axiosInstance";
import authModule from '../auth'
import rbacModule from '../rbac'
import userModule from '../user'
import libraryModule from '../library'
import knowledgeBaseModule from '../knowledgeBase'
import homeModule from "../home";
import cardModule from "../card";
import commentModule from "../comment";
import reportModule from "../report";
import massActionModule from "../massAction";
import groupModule from "../group";
import matrixModule from "../matrix";
import settingsModule from "../setting";
import notificationModule from "../notification";
import orgstructModule from "../orgstruct";
import exportImportModule from "../exportImport";
import homeDashboardModule from "../homeDashboard";
import cascadingModule from "@/modules/cascading/base/cascadingApi";
import evaluationModule from "@/modules/evaluation/base/evaluationApi";
import talentMatrixModule from "@/modules/talentMatrix/base/talentMatrixApi";
import oneToOneModule from "@/modules/oneToOne/base/oneToOneApi";

export default {
    auth: authModule(axiosInstance),
    rbac: rbacModule(axiosInstance),
    user: userModule(axiosInstance),
    library: libraryModule(axiosInstance),
    knowledgeBase: knowledgeBaseModule(axiosInstance),
    home: homeModule(axiosInstance),
    card: cardModule(axiosInstance),
    comment: commentModule(axiosInstance),
    report: reportModule(axiosInstance),
    massAction: massActionModule(axiosInstance),
    group: groupModule(axiosInstance),
    matrix: matrixModule(axiosInstance),
    settings: settingsModule(axiosInstance),
    notification: notificationModule(axiosInstance),
    orgstruct: orgstructModule(axiosInstance),
    exportImport: exportImportModule(axiosInstance),
    homeDashboard: homeDashboardModule(axiosInstance),
    cascading: cascadingModule(axiosInstance),
    evaluation: evaluationModule(axiosInstance),
    talentMatrix: talentMatrixModule(axiosInstance),
    oneToOne: oneToOneModule(axiosInstance),
}